import { render, staticRenderFns } from "./level2Title.vue?vue&type=template&id=f0a09a74&scoped=true"
import script from "./level2Title.vue?vue&type=script&lang=js"
export * from "./level2Title.vue?vue&type=script&lang=js"
import style0 from "./level2Title.vue?vue&type=style&index=0&id=f0a09a74&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0a09a74",
  null
  
)

export default component.exports